import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { RouteConfig } from "../../../route";

const MenuConfig = [
  {
    key: "sceneManege",
    label: "场景管理",
    children: [
      {
        key: "sceneList",
        label: "场景管理",
      },
    ],
  },
  {
    key: "moduleManage",
    label: "模块管理",
    children: [
      {
        key: "modulePage",
        label: "模块管理",
      },
    ],
  },
  {
    key: "userManage",
    label: "用户管理",
    children: [
      {
        key: "userManagement",
        label: "用户管理",
      },
    ],
  },
  {
    key: "systemConfig",
    label: "系统配置",
    children: [
      {
        key: "systemConfigPage",
        label: "系统配置",
      },
    ],
  },
  {
    key: "taskManage",
    label: "任务管理",
    children: [
      {
        key: "taskPage",
        label: "任务管理",
      },
    ],
  },
  {
    key: "videoManage",
    label: "视频工具",
    children: [
      {
        key: "videoMultiAudio",
        label: "多角色语音生成",
      },
    ],
  },
];

function PageMenu() {
  const [currentKey, setCurrentKey] = useState("sceneList");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path === RouteConfig.sceneList.path) {
      setCurrentKey("sceneList");
    } else if (
      path.startsWith(RouteConfig.sceneDetail.path.replace(":id", ""))
    ) {
      setCurrentKey("sceneList");
    } else if (path === RouteConfig.userManagement.path) {
      setCurrentKey("userManagement");
    } else if (path === RouteConfig.systemConfigPage.path) {
      setCurrentKey("systemConfigPage");
    } else if (path === RouteConfig.modulePage.path) {
      setCurrentKey("modulePage");
    } else if (path === RouteConfig.taskPage.path) {
      setCurrentKey("taskPage");
    } else if (path === RouteConfig.videoMultiAudio.path) {
      setCurrentKey("videoMultiAudio");
    }
  }, [location.pathname]);

  const clickMenu = (item: any) => {
    console.log(item);
    setCurrentKey(item.key);
    const route = RouteConfig[item.key as keyof typeof RouteConfig];
    if (route) {
      navigate(route.path);
    }
  };

  return (
    <Menu
      onClick={clickMenu}
      style={{ width: "100%" }}
      defaultOpenKeys={[
        "sceneManege",
        "moduleManage",
        "userManage",
        "systemConfig",
        "taskManage",
        "videoManage",
      ]}
      selectedKeys={[currentKey]}
      mode="inline"
      items={MenuConfig}
    />
  );
}

export default PageMenu;
